import { ConsoleSqlOutlined, ToTopOutlined } from '@ant-design/icons';
import { Spin, message, Row, Col, Tooltip, Divider } from 'antd';
import CommonButton from 'components/ButtonWidgets/CommonButton/CommonButton';
import CommonDivWidget from 'components/CommonDivWidget/CommonDivWidget'
import { TitleSearch } from 'components/SearchWidget/TitleSearch';
import React, { useEffect, useState } from 'react'
import "./GlobalUnitConvertPage.css"
import { showAddNewGlobalUnitConvertDialog } from './GlobalUnitConvertCreateDialog/showAddNewGlobalUnitConvertDialog';
import GlobalUnitConvertTableWidget from './GlobalUnitConvertTableWidget/GlobalUnitConvertTableWidget';
import { apiGetGlobalUnitConvertList, apiDeleteGlobalUnitConvert } from 'services/unitConvertService';

function GlobalUnitConvertPage(props) {
    const { ownCommonData, setOwnCommonData} = props;
    const [isBusy, setIsBusy] = useState(false);
    const [unitListInv, setUnitListInv] = useState([]);
    const [searchListInv, setSearchListInv] = useState([]);
    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        setIsBusy(true);
        apiGetGlobalUnitConvertList()
            .then((data) => {
                setIsBusy(false);
                setUnitListInv(data);
                setSearchListInv(data)
            })
            .catch((err) => {
                setIsBusy(false);
                //message.error("Server failed. " + err);
            });
    };

    
    const createNewUnitInv = async () => {
        var res = await showAddNewGlobalUnitConvertDialog({
            title: "New Global Unit Converstaion",
            isEdit: false,
            oldList: unitListInv,
            ownCommonData : ownCommonData
        });
        if (res == null) return;
        setUnitListInv(res['addedItem']);
        setSearchListInv(res['addedItem'])
        message.success(`new Unit has been created.`);
    };

    const onUpdateActionInv = async (info) => {
        var res = await showAddNewGlobalUnitConvertDialog({
            title: "Edit Global Unit Converstaion",
            isEdit: true,
            oldList: unitListInv,
            ownCommonData : ownCommonData,
            selInfo: info
        });
        if (res == null) return;
        setUnitListInv(res['addedItem']);
        setSearchListInv(res['addedItem'])
        message.success(`Unit has been updated.`);
    }
    const onDeleteActionInv = (pInfo) => {
        setIsBusy(true);
        apiDeleteGlobalUnitConvert(pInfo.id)
            .then((data) => {
                setIsBusy(false);
                setUnitListInv(data);
                setSearchListInv(data);

            })
            .catch((err) => {
                setIsBusy(false);
                message.error(err);
            });
    }

    const handleSearchInv = (searchText) => {
        const tmpList = ownCommonData.unitList.filter((info) => info.name.toLowerCase().includes(searchText.toLowerCase()))
        const tmpList__ =  unitListInv.filter(e=> tmpList.filter(ee => ee.id == e.unit_id) != undefined &&  tmpList.filter(ee => ee.id == e.unit_id).length > 0)
        setSearchListInv([...tmpList__])
    };
    const handleChangeInv = (event) => {
        if (event.target.value === "") {
            setSearchListInv(unitListInv)
        }
        else {
            handleSearchInv(event.target.value)
        }
    };
    return (
            <Spin spinning={isBusy}>
                <Row gutter={[32, 32]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row gutter={[24, 16]}  className="table-bg">
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <h1>Global Unit Conversation</h1>
                                <Row align={"middle"} gutter={16}>
                                    <Col xs={22} sm={22} md={22} lg={22} xl={22}>
                                        <TitleSearch
                                            onSearch={handleSearchInv}
                                            onChange={handleChangeInv}
                                            onPressEnter={handleSearchInv}
                                        />
                                    </Col>
                                    <Col xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <Tooltip title={"Click to add new one."}>
                                            <CommonButton
                                                customClass={"product-upload-basic-unit-add-button"}
                                                onClick={() => {
                                                    createNewUnitInv();
                                                }}
                                            >
                                                New
                                            </CommonButton>
                                        </Tooltip>
                                    </Col>
                                </Row>
                                <div style={{marginTop:10}}>
                                    <GlobalUnitConvertTableWidget
                                        ownCommonData={ownCommonData}
                                        unitList={searchListInv}
                                        onUpdateAction={onUpdateActionInv}
                                        onDeleteAction={onDeleteActionInv}             
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>

            </Spin>
    );
};


export default GlobalUnitConvertPage
